export interface NavigationItem {
  id: string;
  label: string;
  path: string;
  carousel_text: string;
  page_text: string;
  isIcon?: boolean;
}

export const navigationItems: NavigationItem[] = [
  // Pages ordonnées par ordre alphabétique
  {
    id: 'accueil',
    label: 'Accueil',
    path: '/',
    page_text: 'Bienvenue sur notre site dédié à la découverte de la culture algérienne.',
    carousel_text: 'vers l\'acceuil' 
  },
  {
    id: 'histoire',
    label: 'Histoire',
    path: '/histoire', 
    page_text: 'L\'histoire de l\'Algérie est une histoire fascinante, remplie de richesses culturelles et de traditions uniques. Depuis les premiers hommes qui ont peuplé la région, jusqu\'à nos jours, notre pays a été marqué par des événements historiques qui ont façonné son identité et son développement.',
    carousel_text: 'L\'histoire de l\'Algérie est une histoire fascinante, remplie de richesses culturelles et de traditions uniques.'
  },
  {
    id: 'relief-climat',
    label: 'Relief & Climat',
    path: '/relief-climat',
    page_text: 'Le relief de l\'Algérie est structuré selon un axe ouest-est en bandes parallèles, allant du littoral méditerranéen au vaste désert du Sahara. Ces zones présentent des contrastes climatiques forts, façonnés par la géographie du pays.',
    carousel_text: 'Le relief et le climat de l\'Algérie sont uniques et variés, reflétant la diversité géographique de notre pays.'
  },
  {
    id: 'communaute',
    label: 'Peuples',
    path: '/communaute',
    page_text: 'L\'Algérie est un pays riche en diversité culturelle et ethnique. De la côte méditerranéenne aux confins du Sahara, chaque région abrite des communautés aux traditions, langues et coutumes uniques.',
    carousel_text: 'Découvrez la richesse et la diversité des communautés algériennes.'
  },
  {
    id: 'gastronomie',
    label: 'Gastronomie',
    path: '/gastronomie',
    page_text: 'La gastronomie algérienne est un véritable voyage culinaire qui reflète la diversité culturelle de notre pays. Chaque région apporte sa touche unique aux plats traditionnels.',
    carousel_text: 'Découvrez les saveurs authentiques de la cuisine algérienne.'
  },
  {
    id: 'tradition',
    label: 'Tradition',
    path: '/tradition',
    page_text: 'Les traditions algériennes sont le reflet du riche patrimoine culturel. Elles englobent l\'artisanat, la musique, la danse ... se transmettant de génération en génération.',
    carousel_text: 'Les traditions algériennes sont le reflet de notre riche patrimoine culturel.'
  },
  {
    id: 'marketplace',
    label: 'Le Hanout',
    path: '/marketplace',
    page_text: 'Découvrez notre sélection d\'artisanat traditionnel algérien. Chaque pièce est soigneusement sélectionnée pour représenter l\'authenticité et la beauté de notre patrimoine culturel.',
    carousel_text: 'Découvrez notre sélection d\'artisanat traditionnel algérien.',
    isIcon: true
  }
];
